<template>
  <div class="input_attrs_box" :class="{'athena-input':theme ==='athena'}">
    <div
      class="variant_select"
      v-for="(item, index) in product_res.variant_attrs"
      :class="{
        dropdown: variants_show_config != 'label' && theme != 'vogue',
        special_attr_select: is_special_attr(item.special_native_name) && variants_show_config == 'dropdown',
      }"      
      :key="product_res.ID+item.name"
    >
      <!-- vogue主题下拉框的显示方式为左侧弹出,label在选择框中显示，此处不需要显示 -->
      <label
        v-if="!(variants_show_config == 'dropdown' && theme == 'vogue')"
        class="secondary_title"
      >
        {{ item.name }}
      </label>
      <v-labelStyle
        v-if="variants_show_config == 'label'"
        :attrs="item"
        :index="index"
        :variant_attrs="variant_attrs"
        :theme="theme"
      ></v-labelStyle>
      <div v-else-if="item.special_native_name" class="athena-special-select">
        <v-selectStyle
          :attrs="item"
          :index="index"
          :variant_attrs="variant_attrs"
          :show_dropdown="theme == 'athena'"
          :theme="theme"
        ></v-selectStyle>
      </div>      
      <v-selectStyle
        v-else
        :attrs="item"
        :index="index"
        :variant_attrs="variant_attrs"
        :theme="theme"
      ></v-selectStyle>
    </div>
  </div>
</template>
<script>
import vLabelStyle from "./labelStyle.vue";
import vSelectStyle from "./selectStyle.vue";
export default {
  props: {
    variants_show_config: {},
    product_res: {},
    variant_attrs: {},
    theme: {},
  },
  data() {
    return {};
  },
  methods: {
    is_special_attr(name) {
      let { special_attr_key } = this.$store.state
      if (!name || !special_attr_key) return false
      else if (name.toLowerCase() == special_attr_key) return true
    },    
  },
  components: {
    vLabelStyle,
    vSelectStyle,
  },
};
</script>
<style scoped lang='scss'>
.input_attrs_box {
  .variant_select {
    position: relative;
    margin-bottom: 20px;
    & > label {
      color: #1e0909;
      font-family: "Roboto", sans-serif;
      pointer-events: none;
      font-weight: bold;
      font-size: 15px;
      line-height: 1.2;
      // text-transform: capitalize;
    }
    // select {
    //   position: relative;
    //   list-style: none;
    //   direction: ltr;
    //   box-sizing: inherit;
    //   font-size: 100%;
    //   margin: 0;
    //   text-transform: none;
    //   display: block;
    //   border-radius: 0;
    //   height: 48px;
    //   line-height: 22px;
    //   padding: 12px;
    //   color: #1e0909;
    //   border: 1px solid #e4e4e4;
    //   width: 100%;
    //   margin-bottom: 12px;
    //   cursor: pointer;
    //   font-weight: 400;
    //   background: rgba(255, 255, 255, 0.8);
    //   padding-left: 5px !important;
    //   font-family: "Roboto", sans-serif;
    //   border-color: rgba(17, 17, 17, 0.2);
    //   appearance: none;
    //   padding-right: 30px;
    //   transition: 0s;
    // }
    // .labelStyle {
    //   .labelItem {
    //     display: inline-block;
    //     label {
    //       margin: 0;
    //       cursor: pointer;
    //       font-weight: 600;
    //       font-style: normal;
    //       letter-spacing: 0.1em;
    //       line-height: 1;
    //       padding: 9px 11px;
    //       margin: 3px 10px 7px 0px;
    //       font-size: 0.86667em;
    //       font-style: normal;
    //       background-color: #fff;
    //       border: 1px solid #d2d2d2;
    //       color: #222323;
    //       cursor: pointer;
    //     }
    //     input {
    //       clip: rect(0, 0, 0, 0);
    //       overflow: hidden;
    //       position: absolute;
    //       height: 1px;
    //       width: 1px;
    //       // &:focus + label,
    //       // &:active + label {
    //       //   background-color: #f2f2f2;
    //       // }
    //     }
    //   }
    //   .active {
    //     label {
    //       background-color: #1a1a1a;
    //       border-color: #1a1a1a;
    //       color: #fbfbfb;
    //     }
    //   }
    // }
  }
  .dropdown {
    &::after {
      content: "\e62a";
      font-family: "iconfont";
      position: absolute;
      bottom: 15px;
      right: 12px;
      font-size: 15px;
      color: rgba(17, 17, 17, 0.4);
      pointer-events: none;
    }
  }
}
.athena-input {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: -10px;
  margin-right: -10px;
  .variant_select {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    &::v-deep {
      .default-select {
        & > select {
          margin-bottom: 0;
          border-color: #979cac !important;
          color: #222a40 !important;
          padding-left: 20px !important;
          font-weight: 600;         
        }
      }     
    }       
  }  
  .special_attr_select {
    display: inline-block;
    flex: 1;
    max-width: unset;
    min-width: unset;
    &.dropdown {
      &::after {
        content: "";
      }
    }     
  }  
  .athena-special-select {
    &::v-deep {
      .default-select {
        & > select {
          height: 52px;
          padding-left: 20px !important;
          border-color: #979cac !important;
          font-size: 16px;
          color: #222a40 !important;
          font-weight: 600;
          margin-bottom: 0;
        }
      }
      .default-select-dropdown {
        &::after {
          color: #222a40;
          font-weight: 600;
          right: 19px;
        }
      }
    }   
  }     
  .dropdown {
    &::after {
      right: 30px;
      color: #222a40;
      font-weight: bold;
    }
  }  
}
@media screen and (max-width: 768px) {
.athena-input {
  .variant_select {
    &::v-deep {
      .default-select {
        & > select {
          margin-bottom: 0;
          border-color: #979cac !important;
          color: #222a40 !important;
          padding-left: 20px !important;
          font-weight: 600;
          padding: 5px;
          height: 34px; 
        }
      }     
    }       
  }  
  .athena-special-select {
    &::v-deep {
      .default-select {
        & > select {
          height: 34px;
          padding-left: 20px !important;
          border-color: #979cac !important;
          font-size: 13px;
          color: #222a40 !important;
          font-weight: 600;
          margin-bottom: 0;
        }
      }
      .default-select-dropdown {
        &::after {
          color: #222a40;
          font-weight: 600;
          right: 19px;
        }
      }
    }   
  }     
  .dropdown {
    &::after {
      right: 30px;
      color: #222a40;
      font-weight: bold;
      bottom: 9px;
    }
  }  
}  
}
</style>